export const MutationTypes = {
	VISITS: 'VISITS',
	INSTRUCTIONS_VISIBLE: 'INSTRUCTIONS_VISIBLE',
	PAGINATION: 'PAGINATION',
	FEATURES: 'FEATURES',
	COUNTERS: 'COUNTERS'
};
